<script>import { Box } from '../Box';
import useStyles from './Skeleton.styles';
export let use = [], element = undefined, className = '', override = {}, visible = true, height = 'auto', width = 100, circle = null, radius = null, animate = true;
export { className as class };
$: ({ cx, classes, getStyles } = useStyles({ animate, circle, height, radius, width }, { name: 'Skeleton' }));
</script>

<Box
	bind:element
	class={cx(className, classes.root, { visible }, getStyles({ css: override }))}
	{use}
	{...$$restProps}
>
	<slot />
</Box>
